// components/ConfirmDeleteModal.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ModalClearData = ({ show, onClose, onConfirm }) => {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar exclusão</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Tem certeza que deseja apagar os dados da sessão? Essa ação não poderá ser desfeita.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalClearData;
